<script lang="ts">
	import { createEventDispatcher, onMount } from "svelte";

	export let inputType: string
	export let value: string | number = ''
	export let placeholder: string = ''
	export let klass: string = ''
	export let focus : boolean = false
	export let isError: boolean = false
	export let min = undefined
	export let max = undefined
	export let disabled = false
	let element

	const dispatch = createEventDispatcher()

	function input(e: any) {
		dispatch('input', {
			value: e.target.value
		})
	}

	function keypress(e: any) {
		dispatch('keypress', {
			value: e.charCode
		})
	}

	onMount(() => {
		if (focus) {
			element.focus()
		}
	})
</script>

{#if inputType === 'number'}
  <input
  	type={inputType}
  	value={value}
  	class="input-text {klass}"
  	class:is-error={isError}
  	placeholder={placeholder}
  	on:input={input}
  	on:keypress={keypress}
  	bind:this={element}
  	min={min}
  	max={max}
		disabled={disabled}
  >
{:else}
  <input
  	type={inputType}
  	value={value}
  	class="input-text {klass}"
  	class:is-error={isError}
  	placeholder={placeholder}
  	on:input={input}
  	on:keypress={keypress}
  	bind:this={element}
		disabled={disabled}
  >
{/if}

<style lang="postcss">
	.input-text {
		@apply p-3 w-full text-sm;
	}
	.input-text:focus {
		@apply outline-none border-blue-400;
	}
	.is-error {
		@apply outline-none border-red-400;
	}
</style>